import React from "react";
import "./OffersPricing.css";
import Dots from "../../../../assets/images/about-shape3.png";
import Triangle1 from "../../../../assets/images/pricingsec2tri1.png";
import Triangle2 from "../../../../assets/images/pricingsec2tri2.png";
const data = [
  { service: "Tax Audit & Representation (3Years)", price: "Free" },
  { service: "*FBAR", price: "Free" },
  { service: "No charges on 1099-B, 1099-INT/DIV, Crypto", price: "Free" },
  { service: "Extension Filing", price: "Free" },
  {
    service: "Free Tax estimates on your return",
    price: "Free",
  },
  { service: "Indian Tax filing", price: "Free" },
  { service: "Group of 10 clients", price: "15% Discount & Referral Bonus" },
  {
    service: "Group of 20 Clients & more",
    price: "25% Discount & Referral Bonus",
  },
  {
    service: "*Refer your friend & earn on each paid individual",
    price: "$10",
  },
  { service: "*Tax expert consultation With EA & CPA’S", price: "Free" },
  { service: "Tax Transcript", price: "$10" },
];
const OffersPricing = () => {
  return (
    <div className="offers_pricing_section">
      <div className="offers_pricing_tablewrap">
        <img src={Triangle1} alt="" className="offers_pricing_tabletriangle1" />
        <img src={Triangle2} alt="" className="offers_pricing_tabletriangle2" />

        <div className="offers_pricing_table">
          <div className="offers_pricing_tableheading">
            Promotional Offers & Free Services
          </div>
          <div className="offers_pricing_tablecontent">
            <div className="offers_pricingtab_contentheader">
              <div className="offers_pricingtab_chleft">Service</div>
              <div className="offers_pricingtab_chright">Price</div>
            </div>
            {data.map((item, index) => (
              <div
                className="offers_pricingtab_contentitem"
                style={{
                  background:
                    index % 2 === 0
                      ? "rgba(52, 182, 188, 0.2)"
                      : "rgba(52, 182, 188, 0.02)",
                }}
              >
                <div className="offers_pricingtab_cileft">{item.service}</div>
                <div className="offers_pricingtab_ciright">{item.price}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OffersPricing;
